import type { Mission } from '../missions.ts'

export const atf: Mission = {
  id: "atf",
  name: "Bureau of Alcohol, Tobacco, Firearms and Explosives",
  short: "ATF",
  call: "Firearms",
  kind: "subagency",
  parent: "doj",
  url: "https://www.atf.gov/",
  established: 1972,
  palette: {
    primary: "#002c62",
    secondary: "#025295",
    accent: "#f9ba30",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Bureau_of_Alcohol,_Tobacco,_Firearms_and_Explosives.svg",
  },
  motif: "shield",
  mission: {
    text: "ATF protects American communities from violent crime driven by the illegal use of firearms, explosives, and acts of arson.",
    url: "https://www.atf.gov/about",
  },
  fact: {
    text: "On July 1, 1972, the Bureau of Alcohol, Tobacco and Firearms was created with its current mission of preventing violent crimes through the enforcement of firearms and explosives laws.",
    url: "https://www.atf.gov/our-history/our-history",
  },
  seal: {
    file: "public/seals/atf.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Bureau_of_Alcohol,_Tobacco,_Firearms_and_Explosives.svg",
  },
  identifier: {
    about: "https://www.atf.gov/about",
    accessibility: "https://www.justice.gov/accessibility/accessibility-statement",
    foia: "https://www.atf.gov/resource-center/freedom-information-act-foia",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.atf.gov/about/budget-performance",
    privacy: "https://www.justice.gov/doj/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/atf-national-response-team.jpg",
        small: "/media/atf-national-response-team-sm.jpg",
        alt: "A white ATF National Response Team explosives and fire investigation truck with blue stripes parked on a city street.",
        title: "ATF National Response Team command truck, Cleveland, Ohio, May 17, 2024",
        creator: "Raymond Wambsgans",
        source: "https://commons.wikimedia.org/wiki/File:Alcohol_Tobacco_&_Firearms_National_Response_Team_Pierce_command_truck.jpg",
        license: "CC BY 2.0",
      },
      {
        file: "/media/atf-arson-class.jpg",
        small: "/media/atf-arson-class-sm.jpg",
        alt: "A fire investigator with a black accelerant detection dog speaks to students seated on outdoor bleachers during an arson investigation class.",
        title: "Advanced origin and cause arson class, National Center for Explosives Training and Research, Redstone Arsenal, Alabama",
        creator: "The Redstone Rocket, U.S. Army",
        source: "https://commons.wikimedia.org/wiki/File:ATF_Arson_Class.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
